import { SideNavView } from './SideNav'
import { MainContentView } from './MainContent'
import { HeaderView } from './Header'


type LayoutProps = {
  mainContent: React.ReactNode
  legacyStyling?: boolean
}

export const LayoutView = (props: LayoutProps) => {
  const { mainContent, legacyStyling } = props
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
    }}>
      <HeaderView />
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        flexGrow: 1,
        flexShrink: 1,
      }}>
        <SideNavView />
        <MainContentView legacyStyling={!!legacyStyling}>
          {mainContent}
        </MainContentView>
      </div>
    </div>
  )
}
